import React from "react";
import GiftListState, { GiftListProps } from "./GiftList.models";
import './GiftList.scss';
import RewardService from "../../../services/management/RewardService";
import { RewardDTO } from "../../../models/dtos/management/RewardDTO";
import PointsService from "../../../services/management/PointsService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import { NavLink } from "react-router-dom";
import { WordRestrictions } from "../../../models/extension/WordExtention";
import { toast } from "react-toastify";

export default class GiftList extends React.PureComponent<GiftListProps, GiftListState>{
    rewardService: RewardService;
    pointsService: PointsService;
    constructor(props: any) {
        super(props);
        this.rewardService = new RewardService();
        this.pointsService = new PointsService();
        this.state = { rewards: { rows: [], totalRowCount: 0 }, pointCount: { currentPoint: 0, totalPoint: 0 } };
    }

    componentDidMount = () => {
        this.getData();
        this.getPoints();
    }

    getData = () => {
        let self = this;
        self.rewardService.getPages({
            descendingOrder: false,
            orderField: "Point",
            pageSize: 1000,
            pageSkip: 0
        }).then(function (response) {
            self.setState({ rewards: response });
        });
    }
    getPoints = () => {
        let self = this;
        self.pointsService.getPointsCount().then(function (response) {
            self.setState({ pointCount: response });
        });
    }

    selectedRewards = (reward: RewardDTO) => {
        let self = this;
        let state = self.state;

        if (reward.point > state.pointCount.currentPoint) {
            toast.error("امتیاز شما کافی نیست.");
            return;
        }
        else if (reward.point <= state.pointCount.currentPoint) {
            self.rewardService.useReward(reward.id).then(function (response) {
                toast.success("جایزه با موفقیت دریافت شد , در اولین فرصت موسسه با شما تماس میگیرد.");
                self.getPoints();
            })
                .catch(error => {
                    console.log(error);
                    toast.error("دریافت جایزه با خطا مواجه شد.");
                });
        };
    }

    render(): React.ReactNode {
        let { rewards, pointCount } = this.state;
        let content;
        if (rewards.rows.length > 0)
            content = (<>
                {rewards.rows.map((reward, key) => {
                    let canReceiveGift = reward.point <= pointCount.currentPoint;
                    return <div key={key} className={"tk-card gift-list-area " + (canReceiveGift ? "activeReward" : '')} style={{ marginBottom: "30px" }}>
                        <div className={"card-icon " + (canReceiveGift ? "activeReward" : '')}>
                            <label>{reward.point}</label>
                        </div>
                        <div className="card-title">
                            <div className="tk-tooltip">
                                {WordRestrictions(reward.title, 24)}
                                <span className="tk-tooltiptext top">{reward.title}</span>
                            </div>

                            {canReceiveGift ? <>

                                <span onClick={() => this.selectedRewards(reward)} className={'recive-gift active-recive-gift'}>
                                    دریافت</span>
                            </> : <>
                                <button className={"recive-gift " + (canReceiveGift ? "" : "inactive-recive-gift")}
                                    onClick={() => this.selectedRewards(reward)}
                                    style={(reward.point > pointCount.currentPoint ? { opacity: "0.6" } : {})}>
                                    <span className={"mdi " + (canReceiveGift ? 'active-recive-gift' : "mdi-lock")}>
                                        {(canReceiveGift ? ("دریافت") : (''))}</span>
                                </button>
                            </>}
                        </div>
                        <div className="col-12 user-info">
                            <div className="col-12 notspace info" style={{ textAlign: "right" }}>
                                <label>
                                    {reward.description}
                                </label>
                            </div>
                        </div>
                    </div>
                })}
            </>);
        else content = (<NotFoundDataInDate title="موردی یافت نشد" />);

        let headers = (<>
            <NavLink to={"/ReceivedRewards"} className={"gift-list-area"}>
                <div className="col-12 notspace margin-top box-shadow" >
                    <div className="tk-inline card-boundel">
                        <div className="col-2 notspace">
                            <div className="bd-Icon bg-images">
                                <label className="mdi mdi-gift-outline star"></label>
                            </div>
                        </div>
                        <div className="col-10 notspace" style={{ textAlign: "right", marginRight: " 20px" }}>
                            <div className="pd-detail">
                                <div className="title">
                                    <label>جوایز دریافت شده</label>
                                </div>
                                <div className="subtitle">
                                    <label> برای مشاهده جزئیات کلیک کنید</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
        </>);

        return (<>
            {headers}
            <div className="col-12 gift-list-area notspace" style={{ paddingTop: "18px !important" }}>
                <label>لیست جوایز</label>
            </div>
            {content}

        </>);
    }
}